export const useAcceptedFileService = ({ file, feedFile, reelFile }) => {
  const isFeed = file.placement_type === 'feed'
  const isReel = file.placement_type === 'reel'
  
  // Determine button states
  const feedButtonFilled = isFeed || !!feedFile
  const reelButtonFilled = isReel || !!reelFile
  
  return {
    feedButtonFilled,
    reelButtonFilled,
  }
}